import React from "react";
import {
  Container,
  PriceContainer,
  PriceContentWrapper,
  SpanH1,
  SpanP1,
  PriceContainerCards,
  CardContainer,
  Card,
  CardTitle,
  CardPrice,
  CardDescription,
  CardButton,
  CardButtonOutline,
} from "./pricing.styles";
import Navbar from "../Navbar/Navbar";
import { IoCheckmarkOutline } from "react-icons/io5";

const Index = () => {
  const cardData = [
    {
      title: "Standard",
      price: "1.5% + $0.00",
      description:
        "Lorem ipsum dolor sit amet consectetur. Eget viverra nunc sapien tortor ortor.",
    },
    {
      title: "Custom",
      price: "1.5% + $0.00",
      description:
        "Lorem ipsum dolor sit amet consectetur. Eget viverra nunc sapien tortor ortor.",
    },
  ];

  return (
    <Container>
      <Navbar />
      <PriceContainer>
        <PriceContentWrapper>
          <SpanH1>Fair Prices; No Hidden Fees</SpanH1>
          <SpanP1>Prices built for businesses of all sizes</SpanP1>
        </PriceContentWrapper>
        <PriceContainerCards>
          <CardContainer>
            {cardData.map((card, index) => (
              <Card key={index}>
                <CardTitle>{card.title}</CardTitle>
                <CardPrice>{card.price}</CardPrice>
                {[...Array(3)].map((_, i) => (
                  <CardDescription key={i}>
                    <span>
                      <IoCheckmarkOutline />
                    </span>{" "}
                    {card.description}
                  </CardDescription>
                ))}
                {index === 0 ? (
                  <CardButton primary>Get Started</CardButton>
                ) : (
                  <CardButtonOutline>Contact</CardButtonOutline>
                )}
              </Card>
            ))}
          </CardContainer>
        </PriceContainerCards>
      </PriceContainer>
    </Container>
  );
};

export default Index;
